import React, {useState, useEffect, forwardRef} from 'react';
import {Toast} from 'antd-mobile-v2';
import {useStore} from '@/store/hooks';

import './index.less';

export default forwardRef((props, ref) => {
  const {fetchDeptList} = useStore('shopStore');
  const {shop_no, city_no, dept_no, isShow} = props;
  const [list, setList] = useState([]);
  const [selectIdx, setSelectIdx] = useState(0);
  const [val, setVal] = useState('');
  const [params, setParams] = useState({
    query_type: 1,
    page_no: 1,
    page_size: 999,
    shop_no: 0,
  });
  useEffect(async () => {
    await queryDeptList();
  }, [shop_no, city_no]);

  useEffect(() => {
    init();
  }, [list.length]);

  const init = () => {
    if (list.length > 0) {
      if (dept_no) {
        let idx = list.findIndex(item => item.dept_no === Number(dept_no));
        idx = idx >= 0 ? idx : 0;
        onSelect(idx, list[idx], true);
        return;
      }
      onSelect(0, list[0], true);
    }
  };

  const queryDeptList = async () => {
    const {status, shop2dept_list, message} = await fetchDeptList({
      ...params,
      shop_no: shop_no || '',
      city_no: city_no || '',
    });
    if (status === 0) {
      const arr = [{dept_id: 0, dept_name: '所有科室', dept_no: 0}, ...(shop2dept_list || [])];
      setList(arr);
    } else {
      Toast.fail(message);
    }
  };

  const onSelect = (idx, data, flag) => {
    setSelectIdx(idx);
    setVal(data.dept_name);
    if (!flag) onToggle(-1);
    props.onSelect(data);
  };

  const onToggle = flag => {
    props.onToggle(flag);
  };

  return (
    <div className="dep-select">
      <div className="gst-select">
        <div className="gst-select-view" onClick={() => onToggle()}>
          <span className="val">{val}</span>
          <span className="icon icon-arrow" />
        </div>
        {isShow ? (
          <>
            <div className="gst-select-mask" />
            <div className="gst-select-content">
              {list.length &&
                list.map((item, idx) => (
                  <span key={idx} className={idx === selectIdx ? 'active' : ''} onClick={() => onSelect(idx, item)}>
                    {item.dept_name}
                  </span>
                ))}
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
});
